<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Holiday Preview"
      id="admin_edit_holiday_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Edit
      </v-btn>
      <v-btn
        :to="
          '/admin/hollidays/list/view/' +
          $route.params.id +
          '/delete'
        "
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-trash-can</v-icon> Remove Holiday
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="holliday.name"
        :icon="'mdi-party-popper'"
        :img_src="holliday.thumb_nail"
        :facts="view_header_facts"
        :description="holliday.description"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Edit Holiday Form"
      id="admin_edit_holiday_form"
    ></CardedSectionHeader>
    <AdminHollidaysAdd
      @on-show-loader="show_loader"
      @on-hide-loader="hide_loader"
      :is_editing="true"
      :is_loading="is_loading"
      ref="add_hollidays_form_comp_ref"
      @on-success-edit="on_success_edit"
    >
    </AdminHollidaysAdd>
  </div>
</template>
<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import ViewHeader from "../../../components/ViewHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import AdminHollidaysAdd from "./AdminHollidaysAdd";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminHollidaysEdit",
  components: {
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    AdminHollidaysAdd,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      holliday: {
        id: 0,
        name: "",
        description: "",
        starts_on: new Date().toISOString().substr(0, 10),
        ends_on: new Date().toISOString().substr(0, 10),
        thumb_nail: Utils.default_holidays_thumbnail,
      },
    };
  },
  methods: {
    show_loader() {
      this.$emit("on-show-loader");
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    load_holliday(){
      ServerClient.Holidays.get_holiday(
      {
        id: this.$route.params.id,
        is_edit: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.holliday = res;
        this.$refs.add_hollidays_form_comp_ref.init_editing_form(res);
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log(
          "Errors while loading holiday details on admin edit holiday",
          errors
        );
      }
    );
    },
    on_success_edit(){
      this.load_holliday();
    }
  },

  computed: {
    view_header_facts() {
      var facts = [
        { text: "Starts On:", val: this.holliday.starts_on },
        { text: "End On:", val: this.holliday.ends_on },
      ];
      return facts;
    },
  },

  mounted() {
    var holliday_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Edit District",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Holidays",
          disabled: false,
          href: "/admin/hollidays",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/hollidays/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/hollidays/list/view/" + holliday_id,
        },
        {
          text: "Edit",
          disabled: true,
          href:"/admin/hollidays/list/view/"+holliday_id+"/edit" 
        }
      ],
      navbar_cols: 3
    });
    this.load_holliday();
  },
};
</script>

